import { 
  ADD_TOTAL_COUNT ,
  Add_SINGLE_ALERT,
  ADD_MESSAGE_ALERT, 
  // ADD_SINGLE_MESSAGES, 
} from "./constants";

import Chat from "../../Chat";
import jwtDecode from "jwt-decode";
import Profile from "../../Profile";
import Meeting from "../../Meeting";
import MyFunds from "../../MyFunds";
import NewsFeed from "../../NewsFeed";
import DashBoard from "../../DashBoard";
import { Switch } from "react-router-dom";
import FundDetail from "../../FundDetail";
import UpdateUser from "../../UpdateUser";
import FundCompare from "../../FundCompare";
import ProtectdRoute from "./protectedRoute";
import MeetingDetail from "../../MeetingDetail";
import CreateNewUser from "../../CreateNewUser";
import CreateNewPost from "../../CreateNewPost";
import CloudDocument from "../../CloudDocument";
import ManageSchedule from "../../ManageSchedule";
import DocumentDetail from "../../DocumentDetail";
import UserManagement from "../../UserManagement";
import UserPreference from "../../UserPreference";
import React, { useEffect, useState } from "react";
import ContactFCNAdmin from "../../ContactFCNAdmin";
import SearchHedgeFund from "../../SearchHedgeFund";
import AllocatorProfile from "../../AllocatorProfile";
import AllocatorContact from "../../AllocatorContact";
import { useDispatch, useSelector } from "react-redux";
import AllocatorNetworks from "../../AllocatorNetwork";
import { getAlerts, getUnSeenMessages } from "./action";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { alertService } from "@hedgefund/shared/src/Alert";
import MonthlyMeetingDetail from "../../MeetingDetail/monthlyMeetings";
import { Layout, PermissionGate, Permissions } from "@hedgefund/shared";


const ProtectedApp = () => {
  const [connection, setConnection] = useState(null);

  const dispatch = useDispatch();
  var token = sessionStorage.getItem("token") ?? localStorage.getItem("token");
  const alertsFactory = useSelector((state) => state.alertFactory);
  const { alertResult, alertCount, pageCount, totalMessages } = alertsFactory;
  var getPaginatedAlerts = () => {
    dispatch(
      getAlerts({
        page: pageCount,
        perPage: alertCount,
      })
    );
  };

  useEffect(() => {
    if (token != null) {
      const decodeToken = jwtDecode(token);
      const currentDate = new Date();
      const DecodeDateTime = new Date(decodeToken.exp * 1000)
      if (DecodeDateTime > currentDate) {
        dispatch(getUnSeenMessages(decodeToken.UserId));
        getPaginatedAlerts();
      }
      const connect = new HubConnectionBuilder()
        .withUrl(`${window._env_.NOTIFICATION_URL}?access_token=${token}`)
        .withAutomaticReconnect()
        .build();

      setConnection(connect);
      connect.onclose = connectToHub();
    }
  }, []);


  var connectToHub = () => {
    if (connection) {
      connection
        .start()
        .then(() => {
          connection.on("ReceiveMessage", (alert) => {
            dispatch({ type: Add_SINGLE_ALERT, alert });
            alertService.info(alert.alertEvent.bodyText, { autoClose: true });
          });
          connection.on("RecieveChatNotification", (message) => {
            dispatch({ type: ADD_MESSAGE_ALERT, message });
            alertService.info(message.chatEvent.bodyText, { autoClose: true });
          });
          connection.on("RecieveTotalNotification", (total) => {
            dispatch({ type: ADD_TOTAL_COUNT, total });
          });
        })
        .catch((error) => console.log(error));
    }
  };
  useEffect(() => {
    if (connection) {
      connectToHub();
    }
  }, [connection]);

  return (
    <Layout navConf="AllocatorsNav" alerts={alertResult} totalMessages={totalMessages}>
      <Switch>
        <PermissionGate>
          <ProtectdRoute path="/dashboard" Component={DashBoard} />
          <ProtectdRoute path="/hedgefunds" Component={SearchHedgeFund} />
          <ProtectdRoute path="/hedgefund/:id/:fundId?" Component={FundDetail} />
          <ProtectdRoute path="/meeting" Component={MeetingDetail} />
          <ProtectdRoute path="/meet" Component={Meeting} />
          <ProtectdRoute path="/myfund" Component={MyFunds} />
          <ProtectdRoute path="/profile" Component={Profile} />
          <ProtectdRoute path="/newsfeed" Component={NewsFeed} />
          <ProtectdRoute path="/chat" Component={Chat} />
          <ProtectdRoute path="/schedule" Component={ManageSchedule} />
          <ProtectdRoute path="/user/:id" Component={UpdateUser} />
          <ProtectdRoute path="/user" Component={UpdateUser} />
          <ProtectdRoute
            path="/create"
            Component={CreateNewUser}
            permissionName={Permissions?.CREATE_USER?.name}
          />
          <ProtectdRoute path="/createpost" Component={CreateNewPost} />
          <ProtectdRoute path="/management" Component={UserManagement} />
          <ProtectdRoute path="/document/:id" Component={DocumentDetail} />
          <ProtectdRoute path={`/updatepost/:id`} Component={CreateNewPost} />
          <ProtectdRoute
            path="/contact"
            Component={ContactFCNAdmin}
            permissionName={Permissions?.CONTACT_US_PAGE?.name}
          />
          <ProtectdRoute path={`/comparefund/:id`} Component={FundCompare} />
          <ProtectdRoute path={`/my-networks`} Component={AllocatorNetworks} />
          <ProtectdRoute path={`/allocator/:id`} Component={AllocatorProfile} />
          <ProtectdRoute path={`/calendar`} Component={MonthlyMeetingDetail} />
          <ProtectdRoute path={`/user-preference`} Component={UserPreference} />
          <ProtectdRoute path={`/cloud-document/:id`} Component={CloudDocument} />
          <ProtectdRoute path={`/allocator-contacts`} Component={AllocatorContact} />

          {/* <ProtectdRoute path="/user-management" Component={UserManagement} /> */}
          <ProtectdRoute path="/" Component={DashBoard} />

        </PermissionGate>
      </Switch>
    </Layout>
  );
};

export default ProtectedApp;
